import React, { useState } from "react";
import { Button, Checkbox, FormControl, IconButton, InputLabel, LinearProgress, MenuItem, Select, TextField, useTheme } from "@material-ui/core/";
import MuiTable from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableContainer from "@material-ui/core/TableContainer";
import ReceiptIcon from "@material-ui/icons/Receipt";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import {
  useTable,
  useSortBy,
  useFilters,
  useGlobalFilter,
  useRowState,
  HeaderProps,
  Row,
  Cell,
} from "react-table";
import { Link } from "react-router-dom";
import MuiLink from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import { Alert, AlertTitle } from "@material-ui/lab";
import { generalFilter, useDefaultColumn } from "../../../../../util/filter";
import { useCreateReportResult, useReportResult, useReportSequenceTypes, useReportTypes } from "../../../projectManagementQueries";
import { ErrorMessage } from "../../../../common/ErrorMessage";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import CallSplitIcon from "@material-ui/icons/CallSplit";
import { AssignedReportsList } from "../../custom_reports/AssignedReportsList";
import { toast } from "react-toastify";
import { noop } from 'lodash';
import { useAuthContext } from "../../../../common/AuthContext";
import { useQueries, useQueryClient } from "react-query";
import { ReportTraveler } from "../../reportTraveler/ReportTraveler";

export const WorkOrderReportAssignment = ({
  workOrderId,
}: {
  workOrderId: string;
}) => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const { state } = useAuthContext();
  const [selectedRSD, setSelectedRsd] = useState("");
  const queryClient = useQueryClient()

  const defaultColumn = useDefaultColumn();
  const [reportTypesTableData, setReportTypesTableData] = React.useState<any>(
    []
  );
  const [workOrderUnitsTableData, setWorkOrderUnitsTableData] =
    React.useState<any>([]);

  const {
    data: reportSequenceData,
    isError: isErrorReportSequence,
    isSuccess: isSuccessReportSequence,
    error: errorReportSequence,
    isLoading: isLoadingReportSequence,
  } = useReportSequenceTypes();

  const {
    data: AssignedReportsListData,
    isError: isErrorAssignedReportsList,
    isSuccess: isSuccessAssignedReportsList,
    error: errorAssignedReportsList,
    isLoading: isLoadingAssignedReportsList
  } = useReportResult(workOrderId);


  const [reportEnabled, setReportEnabled] = useState(false);

  const openDeliverableDialog = () => {

    setOpen(true);
  };

  const { mutateAsync: mutate } = useCreateReportResult();


  const setReportSequence = async (item: any) => {
    try {
      await mutate({
        work_order_id: workOrderId,
        report_sequence_definition_id: item.id,
        username: state.user,
      });
      queryClient.invalidateQueries(["report_result_data", workOrderId]);

    } catch (error) {
      toast.error("Error while set report sequence");
    }

    setReportEnabled(true);
    setSelectedRsd("1")
    queryClient.invalidateQueries(["reportResultData", workOrderId]);

  }

  const [selectedSerial, setSelectedSerial] = useState<string | null>(null);
  
  const [openReportTravelerDialog, setOpenRepoertTravelerlDialog] = React.useState(false);

  const handleOpen = (travelerData : any) => {
    setOpenRepoertTravelerlDialog(!openReportTravelerDialog);

  };




  React.useEffect(() => {
    if (isSuccessAssignedReportsList) {
      setReportEnabled(true);
    }
  }, [reportEnabled]);


  if (isLoadingAssignedReportsList) {
    return <LinearProgress />
  }


  return (

    <div style={theme.container}>
      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
        spacing={5}
      >
        <Grid item xs={12}>
          <Typography variant="h5">Work Order Units</Typography>
        </Grid>
        <Grid item xs={12}>
          {/* <Button onClick={openDeliverableDialog} style={theme.btnNew}>
            View Deliverables
          </Button> */}
        </Grid>

        <Grid
          container
          justifyContent="center"
          alignItems="center"
          spacing={2}
        >
          <Grid item xs={4}
          >

            <TextField
              id="report_sequence"
              label="Report sequence"
              name="report_sequence_select"
              disabled={AssignedReportsListData.length > 0 ? true : false}
              defaultValue={AssignedReportsListData.length > 0 && AssignedReportsListData[0].report_sequence_definition_id}
              select
              fullWidth
              variant="outlined"
              size="small"

            >
              {reportSequenceData?.map((rsd: any) => (
                <MenuItem

                  key={rsd.id}
                  onClick={() =>
                    setReportSequence(rsd)
                  }
                  value={rsd.id}
                >
                  {rsd.name}
                </MenuItem>
              ))}
            </TextField>
            {AssignedReportsListData.length!==0 && 
            <Button
              style={{
                textAlign: "center",
                marginTop: 16,
                marginBottom: 16,
              }}
              variant="contained"
              color="primary"
              onClick={() => handleOpen(AssignedReportsListData)}
              fullWidth
              startIcon={<ReceiptIcon />}
            >
              Report Traveler
            </Button>}

          </Grid>

        </Grid>
        
          <ReportTraveler travelerData={AssignedReportsListData} travelerOpen={openReportTravelerDialog} handleTraveler={handleOpen} />
        
        <Paper style={{ marginTop: 20, marginLeft: 20, marginRight: 20 }}>
          {AssignedReportsListData.length > 0 && <AssignedReportsList data={AssignedReportsListData} />}
        </Paper>
      </Grid>

    </div>
  );
};